import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";

/**
 * The guests' order displays (TastyODS) — CagistaServices /api/ods/** (ADMIN, SUPER_ADMIN). The screens themselves talk
 * to TastyODS, never to this.
 */
class OdsService {
    getDisplays() {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.get('/api/ods/getDisplays?merchant=' + user.merchant, { headers: authHeader() });
    }

    pairDisplay(locationId, code, name) {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/ods/pairDisplay', { merchant: user.merchant, locationId, code, name }, { headers: authHeader() });
    }

    createDisplayLink(locationId, name) {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/ods/createDisplayLink', { merchant: user.merchant, locationId, name }, { headers: authHeader() });
    }

    reloadDisplay(displayId) {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/ods/reloadDisplay', { merchant: user.merchant, displayId }, { headers: authHeader() });
    }

    renameDisplay(displayId, name) {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/ods/renameDisplay', { merchant: user.merchant, displayId, name }, { headers: authHeader() });
    }

    removeDisplay(displayId) {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/ods/removeDisplay', { merchant: user.merchant, displayId }, { headers: authHeader() });
    }
}

export default new OdsService();
